import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Configuração Email", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "fill-height": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "bg-surface px-2 py-2 h-100",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "bg-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Dados do Usuário ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_form, {
            ref: "form",
            modelValue: _ctx.valid,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.valid) = $event)),
            "validate-on": "blur",
            onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { dense: true }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            ref: "api",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.configuracao.urlApi,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.configuracao.urlApi) = $event)),
                            rules: [_ctx.requerid],
                            label: "URL Api",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            ref: "api",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.configuracao.userApi,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.configuracao.userApi) = $event)),
                            rules: [_ctx.requerid],
                            label: "Usuário Api",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            ref: "api",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.configuracao.passApi,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.configuracao.passApi) = $event)),
                            rules: [_ctx.requerid],
                            label: "Senha Api",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            density: "compact",
                            modelValue: _ctx.configuracao.usuarioAtualSistema,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.configuracao.usuarioAtualSistema) = $event)),
                            rules: [_ctx.requerid],
                            label: "Usuário SAF",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            density: "compact",
                            type: "number",
                            autofocus: "",
                            modelValue: _ctx.configuracao.senhaAtualSistema,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configuracao.senhaAtualSistema) = $event)),
                            rules: [_ctx.requerid],
                            label: "Senha SAF",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_1,
                  _hoisted_2,
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_row, { dense: true }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "9" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            ref: "host",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.configuracao.emailHost,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.configuracao.emailHost) = $event)),
                            rules: [_ctx.requerid],
                            label: "Host Email",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            ref: "Porta",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.configuracao.emailPorta,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.configuracao.emailPorta) = $event)),
                            rules: [_ctx.requerid],
                            label: "Porta",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            ref: "requeAuth",
                            density: "compact",
                            modelValue: _ctx.configuracao.emailSmtpAuth,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.configuracao.emailSmtpAuth) = $event)),
                            F: "",
                            label: "Requer Autenticação"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            ref: "emailTLSEnabled",
                            density: "compact",
                            modelValue: _ctx.configuracao.emailTLSEnabled,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.configuracao.emailTLSEnabled) = $event)),
                            label: "TLS"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            ref: "emailTLSRequired",
                            density: "compact",
                            modelValue: _ctx.configuracao.emailTLSRequired,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.configuracao.emailTLSRequired) = $event)),
                            label: "TLS Obrigatório"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            ref: "Usuario",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.configuracao.emailUserName,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.configuracao.emailUserName) = $event)),
                            rules: [_ctx.requerid],
                            label: "Usuário",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            type: "password",
                            ref: "senha",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.configuracao.emailPassword,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.configuracao.emailPassword) = $event)),
                            rules: [_ctx.requerid],
                            label: "Senha",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_textarea, {
                            ref: "texto",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.configuracao.textoEmailRecupearSenha,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.configuracao.textoEmailRecupearSenha) = $event)),
                            rules: [_ctx.requerid],
                            label: "Texto Padrão Recuperar Senha",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            ref: "emailteste",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.emailTest,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.emailTest) = $event)),
                            label: "Email Teste"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            size: "large",
                            type: "button",
                            variant: "flat",
                            class: "text-white flex-grow-1 text-none w-100",
                            color: "blue-darken-4",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.testarEmail()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Testar Envio Email ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    justify: "space-between",
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            size: "large",
                            type: "submit",
                            variant: "outlined",
                            class: "mt-4 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Confirmar ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "warning",
                            size: "large",
                            type: "button",
                            variant: "outlined",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hasHistory() ? _ctx.$router.go(-1) : _ctx.$router.push('/'))),
                            class: "mt-4 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Cancelar ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}